import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestItem } from "../../../../pages/request/list/item/item";

interface IDetailRequestFormState {
    list?: IRequestItem[];
    loading: boolean;
    autoReload?:boolean;
}

const initialState: IDetailRequestFormState = {
    loading: false,
};

export const requestListReducer = createSlice({
    name: "requestList",
    initialState,
    reducers: {
        resetRequestList: () => initialState,
        setRequestListData: (state, action: PayloadAction<IRequestItem[]>) => {
            state.list = action.payload;
        },
        setLoadingRequestList: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
       
    },
});

export const { resetRequestList, setLoadingRequestList, setRequestListData } = requestListReducer.actions;

export default requestListReducer.reducer;
